export default "__VITE_ASSET__mD0ak8f5__"